var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEbayAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5685 11.4197C73.9333 3.80477 63.0681 3.80474 61.4328 11.4197L56.68 33.5531C54.1918 45.1401 45.1406 54.1913 33.5536 56.6795L11.4202 61.4324C3.80527 63.0676 3.80523 73.9328 11.4202 75.568L33.5536 80.3208C45.1406 82.809 54.1918 91.8602 56.68 103.447L61.4328 125.581C63.068 133.196 73.9333 133.196 75.5685 125.581L80.3213 103.447C82.8095 91.8603 91.8607 82.809 103.448 80.3208L125.581 75.568C133.196 73.9328 133.196 63.0676 125.581 61.4324L103.448 56.6795C91.8607 54.1913 82.8095 45.1401 80.3213 33.5531L75.5685 11.4197Z",
    fill: "url(#ebay-ai_svg__paint0_linear_1372_23676)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ebay-ai_svg__paint0_linear_1372_23676",
    x1: 186.995,
    y1: 96.858,
    x2: 97.871,
    y2: 192.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#FFD80E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#FF4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#993EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#0968F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#4EE04B"
  })))));
}

export default SvgEbayAi;